<template>
  <div class="card promo-card">
    <div class="card-image">
      <div class="thumb" :class="'format-'+format">
        <div class="aspect-container">
          <div class="aspect-enforcer"></div>
          <router-link :to="optLink" >
            <div class="aspect-box book">
              <img v-if="optImage" :src="optImage" alt="optTitle">
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div v-if="optTitle" class="card-content">
      <div class="content">
        <router-link :to="optLink">
          <h2 class="title is-5">{{optTitle}}</h2>
        </router-link>        
        <slot><span v-html="desc"/></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Firebase from '../firebase.js'
var db = Firebase.database

export default {
  name: 'GalleryCard',
  props: {
    bookid: { type: String },
    link: { type: String },
    title: { type: String },
    image: { type: String },
    desc: { type: String },
  },
  computed: {
    book: function() { return this.bookdata || {} },
    optLink: function() { return this.link || '/gallery/'+this.bookid },
    format: function() { return this.book.format || 'a4' },
    optImage: function() {
      if (this.image) {return this.image}
      else if (this.book && this.book.pages ) {return this.book.pages[0].img}
      else return undefined
    },
    optTitle: function() {
      return this.title===undefined ? this.book.title : this.title
    },
  },
  methods: {
    loadBook: function() { 
      if (this.bookid) {
        this.$bindAsObject("bookdata", db.ref('/gallery/'+this.bookid))
      }
    },
  },
  watch: {
    bookid: function() {
      this.loadBook()
    }
  },
  beforeMount: function() {
    this.loadBook()
  },
}
</script>

<style scoped>
.promo-card {width: 100%; background: inherit !important; }
.promo-card .title { margin-bottom: 1ex;}

.card-image {
    padding: 1px;
}
.thumb {
    padding: 1em 2em 0 2em;
}
.aspect-container {
    position: relative;
    padding: 1px;
}
.aspect-enforcer {
    position: relative;
}
.format-a4 .aspect-enforcer {
    margin-top: 141.42%; /* 297:210 */
}
.format-pa4 .aspect-enforcer {
    margin-top: 133.33%; /* 280:210 */
}
.format-a4r .aspect-enforcer {
    margin-top: 70.70%; /* 210:297 */
}
.aspect-box {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 6px 6px 10px 1px rgba(0,0,0,.7);
    transform: rotate(-3deg);
    background-color: #555;
    transition: transform .3s, box-shadow .3s;
}
.aspect-box:hover {
    transform: rotate(0deg) scale(1.1);
    box-shadow: 7px 7px 10px 1px rgba(0,0,0,.7);
}

.card {
    box-shadow: none;
}
.card-content .content {
    overflow-x: hidden;
}
.title {
    text-align: center;
}
.book {
    background: url(/static/loading_spinner.gif) no-repeat center center #222;
}

</style>



// WEBPACK FOOTER //
// src/components/GalleryCard.vue